import { render, staticRenderFns } from "./EducativeServiceDocumentManagement.vue?vue&type=template&id=64c44932&scoped=true"
import script from "./EducativeServiceDocumentManagement.vue?vue&type=script&lang=js"
export * from "./EducativeServiceDocumentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c44932",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c44932')) {
      api.createRecord('64c44932', component.options)
    } else {
      api.reload('64c44932', component.options)
    }
    module.hot.accept("./EducativeServiceDocumentManagement.vue?vue&type=template&id=64c44932&scoped=true", function () {
      api.rerender('64c44932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingHistory/components/EducativeServiceDocumentManagement.vue"
export default component.exports